module.exports = __webpack_public_path__ + "static/media/pliance.75fb7973.svg";